import React from 'react';
import { render } from 'react-dom';
import CoopsList from './apps/CoopList/CoopsList';

// Events List Application
const coopsList = document.getElementById('coops-app');
if (coopsList) render(<CoopsList {...coopsList.dataset} />, coopsList);
